import { RouteLocationNormalized, RouteRecordName } from 'vue-router'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const whiteList: (RouteRecordName | null | undefined)[] = ['workspace-list', 'auth-invite', 'auth-invite-user']
  const initialized = useState('initialized')

  if (!initialized?.value) {
    return
  }

  if (!to || !to.name) {
    return
  }

  if (whiteList.includes(to.name)) {
    return
  }

  return checkRoutePermission(to.name.toString(), true)
})
